<template>
  <v-card>
    <v-card-title class="py-0" style="height: 64px">
      <span class="title">事件发送</span>
      <v-btn color="primary" flat @click="addReceiver()">添加发送人</v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text style="max-height: 500px">
      <v-container class="pt-0" fluid grid-list-md>
        <v-form ref="sendForm">
          <v-layout column>
            <v-radio-group mandatory row v-model="eventInfo.isDate" label="发送方式" prepend-icon="$vuetify.icons.lock">
              <v-radio :value="false" label="即时发送"></v-radio>
              <v-radio :value="true" label="定时发送"></v-radio>
            </v-radio-group>
            <l-select-datetime v-model="eventInfo.date" label="发送时间" v-if="eventInfo.isDate" :rules=[$rules.requiredS()]></l-select-datetime>
          </v-layout>
          <v-card class="pa-2 mt-2"  v-for="(r,i) in receiverList" :key="i">
            <v-layout column >
              <v-flex xs12>
                <v-text-field label="用户ID" prepend-icon="$vuetify.icons.person" v-model="r.userId"></v-text-field>
              </v-flex>
              <v-btn flat color="primary" @click="r.showConfig=!r.showConfig" v-if="!r.showConfig">配置事件关联模板</v-btn>
              <v-btn flat color="primary" @click="r.showConfig=!r.showConfig" v-if="r.showConfig">关闭事件关联模板配置</v-btn>
              <v-card class="pa-3" v-for="(t,i) in r.templateInfo" v-if="r.showConfig">
                <v-card-title>
                  <P>{{t.name}}</P>
                </v-card-title>
                <v-layout column>
                  <v-flex xs12>
                    <v-text-field label="接收地址" prepend-icon="$vuetify.icons.location" v-model="t.address" :rules="[$rules.requiredS()]"></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea v-model="t.content" rows="1" auto-grow label="发送预览" prepend-icon="$vuetify.icons.comment" :rules="[$rules.requiredS()]">
                    </v-textarea>
                  </v-flex>
                  <v-layout v-for="(l,i) in t.labelList" :key="i">
                    <v-flex xs4>
                      <v-text-field label="标签名称" prepend-icon="$vuetify.icons.title" v-model="l.name" :rules="[$rules.requiredS()]"></v-text-field>
                    </v-flex>
                    <v-flex xs8>
                      <v-text-field label="标签配置" prepend-icon="$vuetify.icons.code" v-model="l.value" :rules="[$rules.requiredS()]"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-card>
            </v-layout>
          </v-card>
        </v-form>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary" @click="sendMessage" :loading="loading">发送</v-btn>
      <v-btn large color="grey" flat @click="cancel()">取消</v-btn>
      <!--<v-btn :loading="actionLoading" large color="primary" flat @click="send()">发送</v-btn>-->
    </v-card-actions>
  </v-card>
</template>

<script>
let variablePattern = /({[^{}]+})/g
export default {
  name: 'sendMessageContent',
  props: {
    item: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      loading: false,
      eventInfo: {
        templateInfo: [],
        id: '',
        institutionId: '',
        date: '',
        isDate: false
      },
      receiverList: []
    }
  },
  created () {
    console.log(this.item)
    this.init()
  },
  methods: {
    init () {
      this.eventInfo.id = this.item.id
      this.eventInfo.institutionId = this.item.institutionId
      this.dealTemplate()
    },
    async dealTemplate () {
      for (let i = 0; i < this.item.eventTmplts.length; i++) {
        let t = this.item.eventTmplts[i].msgTmplt
        let pagination = {pages: 1, rowsPerPage: 10}
        let url = '/messageApi/admin/getMsgTmplt'
        let {items, amount} = await this.$store.dispatch('message/getList', {pagination, search: {key: 'id', value: t.id}, url: url})
        if (items.length === 0) {
          this.$L.alert('error', {message: '未查询到模板'})
          return
        }
        t = items[0]
        let obj = {
          name: t.name,
          content: t.tmpltContent,
          type: t.type,
          labelList: []
        }
        for (let j = 0; j < t.tmpltBizs.length; j++) {
          let l = {
            name: t.tmpltBizs[i].msgLabelBiz.name,
            value: ''
          }
          obj.labelList.push(l)
        }
        for (let j = 0; j < t.tmpltSyss.length; j++) {
          let label = '{' + t.tmpltSyss[i].msgLabelSys.name + '}'
          let newStr = obj.content.replace(label, t.tmpltSyss[i].msgLabelSys.value)
          obj.content = newStr
        }
        this.eventInfo.templateInfo.push(obj)
      }
      console.log(this.eventInfo)
    },
    addReceiver () {
      let r = {
        userId: '',
        templateInfo: [],
        showConfig: false
      }
      for (let i = 0; i < this.eventInfo.templateInfo.length; i++) {
        let tmp = {
          address: '',
          name: this.eventInfo.templateInfo[i].name,
          labelList: [],
          content: this.eventInfo.templateInfo[i].content,
          type: this.eventInfo.templateInfo[i].type
        }
        for (let j = 0; j < this.eventInfo.templateInfo[i].labelList.length; j++) {
          let l = this.eventInfo.templateInfo[i].labelList[j]
          let obj = {
            name: l.name,
            value: ''
          }
          tmp.labelList.push(obj)
        }
        r.templateInfo.push(tmp)
      }
      this.receiverList.push(r)
    },
    cancel () {
      this.$emit('cancel')
    },
    async sendMessage () {
      if (this.$refs.sendForm.validate()) {
        let params = {}
        let userIdList = []
        let addressList = []
        let labelList = []
        for (let i = 0; i < this.receiverList.length; i++) {
          let r = this.receiverList[i]
          userIdList.push(r.userId)
          let address = {}
          let label = {}
          for (let j = 0; j < r.templateInfo.length; j++) {
            let t = r.templateInfo[j]
            address[t.type] = t.address
            label[t.type] = []
            for (let k = 0; k < t.labelList.length; k++) {
              let l = t.labelList[k]
              label[t.type].push(l.value)
            }
          }
          addressList.push(address)
          labelList.push(label)
        }
        if (this.eventInfo.isDate) {
          params = {
            'eventId': this.eventInfo.id,
            'userIdList': userIdList,
            'institutionId': this.eventInfo.institutionId,
            'addressList': addressList,
            'labelsList': labelList,
            'date':this.$L.time.toTimeStamp(this.eventInfo.date)
          }
        }
        else {
          params = {
            'eventId': this.eventInfo.id,
            'userIdList': userIdList,
            'institutionId': this.eventInfo.institutionId,
            'addressList': addressList,
            'labelsList': labelList,
          }
        }
        this.loading = true
        try {
          let res = await this.$store.dispatch('message/sendMsgByEvent', params)
          console.log(res)
        }
        catch (e) {
          console.log(e)
        }
        finally {
          this.loading = false
        }
      }
      else {
        this.$L.alert('error', {message: '表单数据错误'})
      }
    }
  },
  watch: {
    'receiverList': {
      handler (val) {
        for (let i = 0; i < this.receiverList.length; i++) {
          let r = this.receiverList[i]
          for (let j = 0; j < r.templateInfo.length; j++) {
            let tmp = r.templateInfo[j]
            let t = this.eventInfo.templateInfo[j].content
            let names = t.match(variablePattern) || []
            let contents = []
            for (let k = 0; k < names.length; k++) {
              for (let l = 0; l < tmp.labelList.length; l++) {
                if (names[k] === '{' + tmp.labelList[l].name + '}') {
                  contents.push(tmp.labelList[l].value)
                  break
                }
              }
            }
            //console.log(names)
            let newText = ''
            for (let k = 0; k < names.length; ++k) {
              let idx = t.indexOf(names[k])
              let content = (contents[k] === '') ? names[k] : contents[k]
              newText += t.slice(0, idx + names[k].length).replace(names[k], content)
              // console.log(`replace ${idx + names[i].length}`, t.slice(0, idx + names[i].length), names[i], content)
              t = t.slice(idx + names[k].length)
            }
            newText += t
            tmp.content = newText
          }
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>

</style>
